/* eslint-disable jira/filename-case */
import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from './createJpdExperience.tsx';
import type {
	ExperienceErrorReason,
	ExperienceMetadataExtra,
	JPDExperience,
} from './ExperienceMetadataExtra.types.tsx';

export const getView: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.view.get-view', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const updateView: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.view.update-view', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export type JpdExperienceDeleteViewMetadata = {
	metadata: {
		location: 'navigation' | 'view-header';
		containerType: 'project' | 'collection';
		viewId: string;
	};
};

export const deleteView: JPDExperience<ExperienceErrorReason, JpdExperienceDeleteViewMetadata> =
	createJpdExperience<ExperienceErrorReason, JpdExperienceDeleteViewMetadata>(
		new UFOExperience('jpd.view.delete-view', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

/**
 * Since field updates can be frequent, makeGenericIssueFieldUpdate is a factory
 * to avoid conccurency problems as JPDExperience objects are singletons.
 */
export const makeGenericIssueFieldUpdate = (): JPDExperience<
	ExperienceErrorReason,
	ExperienceMetadataExtra
> =>
	createJpdExperience(
		new UFOExperience('jpd.issue-update.field', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
			timings: [
				{ key: 'internal_state', endMark: 'backend_request_start' },
				{ key: 'backend_request', startMark: 'backend_request_start' },
			],
		}),
	);

export const updateIssueFields: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.issue-update.fields', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
			timings: [
				{ key: 'internal_state', endMark: 'backend_request_start' },
				{ key: 'backend_request', startMark: 'backend_request_start' },
			],
		}),
	);
